/**
 * Lightweight replacement for screen-size-detector.
 * Exposes width/height used by testimonials carousels via window.screen.
 */
export default class ScreenSizeDetector {
  constructor() {
    this._update();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", () => this._update());
    }
  }

  _update() {
    this.width =
      typeof window !== "undefined"
        ? window.innerWidth || document.documentElement.clientWidth || 0
        : 0;
    this.height =
      typeof window !== "undefined"
        ? window.innerHeight || document.documentElement.clientHeight || 0
        : 0;
  }
}
